import React, { useState, useEffect } from "react";
import { Box } from "@mui/material";
import { styled } from "@mui/system";
import Cookies from "js-cookie";
import { Link, useNavigate } from "react-router-dom";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  TextField,
  Typography,
} from "@mui/material";
import { kioskModel, teleConsultationModel } from "../Axios/AxiosConfig";
import { LocalizationProvider, StaticDatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { toast, Zoom } from "react-toastify";
import LoadingComponent from "../loading"
import usePrescriptionStore from "../DataRepository/Prescription";


const CalendarContainer = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  marginBottom: "20px",
});

const DayBox = styled(Box)(({ theme, isSelected }) => ({
  padding: theme.spacing(2),
  backgroundColor: isSelected ? "var(--themePrimaryColor, #DA6E0B)" : "var(--themeSecondaryColor, #F1EFEC)",
  color: isSelected ? "#fff" : "#000",
  borderRadius: "4px",
  textAlign: "center",
  cursor: "pointer",
  margin: "0 5px",
}));

const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
  borderRadius: "10px",
  marginRight: "1rem",
  overflow: "auto",
  margin: "2rem",
}));

const StyledTableHead = styled(TableHead)(({ theme }) => ({
  backgroundColor: "var(--themeSecondaryColor, #E7E7DB)",
  borderRadius: "10px",
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    // backgroundColor: theme.palette.action.hover,
  },
}));

const TimingCell = styled(TableCell)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  fontWeight: "bold",
  gap: "8px",
}));

const TimingButton = styled(Button)(({ theme }) => ({
  minWidth: "32px",
  height: "32px",
  // borderRadius: '50%',

  backgroundColor: "var(--themeSecondaryColor, #C0B7A7)",
  color: "white",
}));

const DATE_SIZE = 32;

const ModeCell = styled(TableCell)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
}));

const ModeButton = styled(Button)(({ theme }) => ({
  marginLeft: "8px",
}));

const getKioskStyles = (name) => {
  if (!name) return { bgcolor: "#f5f5f5", color: "#666" };
  const colors = [
    { bgcolor: "#FBF1E7", color: "#E69E5C" }, // goldorange50 / goldorange300
    { bgcolor: "#DBF9DB", color: "#1C8686" }, // mildgreen / goldorange (teal)
    { bgcolor: "#8CEB8C", color: "#3B362A" }, // ulvalactucagreen / sensaichabrown
    { bgcolor: "#FDFDFD", color: "#1C8686" }, // brilliance / goldorange (teal)
    { bgcolor: "#F4ECD6", color: "#E69E5C" }, // blondecurl200 / goldorange300
    { bgcolor: "#DBF9DB", color: "#75623F" }, // mildgreen / YellowMetal
    { bgcolor: "#FBF1E7", color: "#1C8686" }, // goldorange50 / goldorange (teal)
    { bgcolor: "#E7E7DB", color: "#E69E5C" }, // blondecurl / goldorange300
    { bgcolor: "#8CEB8C", color: "#75623F" }, // ulvalactucagreen / YellowMetal
    { bgcolor: "#F8F2E3", color: "#1C8686" }, // blondecurl300 / goldorange (teal)
  ];
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  const index = Math.abs(hash) % colors.length;
  return colors[index];
};

const Appointments = () => {

  const [selectedDay, setSelectedDay] = useState(dayjs());
  const [currentdate, setcurrentdate] = useState(new Date());
  const [consultationData, setconsultationData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [appointments, setAppointments] = useState([]);
  const [filteredAppointments, setFilteredAppointments] = useState([]);
  const [isLast30Days, setIsLast30Days] = useState(false); // State for fallback notification

  const navigate = useNavigate();
  const { setSelectedAppointemntdetails } = usePrescriptionStore();

  const handleSelectDay = (newValue) => {
    setSelectedDay(newValue);
    setIsLast30Days(false); // Reset on date change
  };

  const kioskDetailsCookie = Cookies.get("kiosk_details");
  let kiosk_details = {};

  if (kioskDetailsCookie) {
    try {
      kiosk_details = JSON.parse(kioskDetailsCookie);
    } catch (error) {
      console.log("Error parsing kiosk_details cookie:", error);
    }
  }
  const UpdateAppointment = async (AppointmentID, key, value) => {
    try {
      setLoading(true);

      const res = await teleConsultationModel.put("/UpdateOneAppointment", {
        AppointmentID,
        key,
        value,
      });

      if (res?.status === 200) {
        getAppointmentData();
        toast.success("Confirmed Appointment Successfully", {
          position: "top-center",
          limit: 1,
          transition: Zoom,
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const getAppointmentData = async () => {
    try {
      setLoading(true);
      const isToday = selectedDay.isSame(dayjs(), "day");
      const dateStr = selectedDay.format("YYYY-MM-DD");

      let res = await kioskModel.post("getClinicalKioskReportbyDate", {
        date: dateStr,
        kiosk_id: kiosk_details?.kiosk_id,
      });

      if (res.status === 200 && res.data.length > 0) {
        setconsultationData(res.data);
        setIsLast30Days(false);
      } else if (isToday) {
        // Fallback for Today: Fetch all patients and filter for last 30 days
        const allPatientsRes = await kioskModel.post("/getAllClinicalPatients", {
          kiosk_id: kiosk_details?.kiosk_id,
        });

        if (allPatientsRes.status === 200) {
          const thirtyDaysAgo = dayjs().subtract(30, "day");
          const filtered = (allPatientsRes.data || []).filter((p) => {
            const createdDate = dayjs(p.created_at);
            return (
              createdDate.isAfter(thirtyDaysAgo) &&
              createdDate.isBefore(dayjs().add(1, "day"))
            );
          });
          setconsultationData(filtered);
          setIsLast30Days(true);
        } else {
          setconsultationData([]);
        }
      } else {
        setconsultationData([]);
        setIsLast30Days(false);
      }
    } catch (err) {
      console.log(err);
      toast.error("Failed to fetch appointment data");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getAppointmentData();
  }, [selectedDay]);

  // Fallback logic is now handled inside getAppointmentData



  const getAllAppointmentData = async () => {
    try {

      const res = await kioskModel.post("/getAllClinicalPatients", {
        kiosk_id: kiosk_details?.kiosk_id,
      });

      if (res.status === 200) {
        setAppointments(res.data || []);
        setFilteredAppointments(res.data || []);
      }

      else {
        console.log("Failed to fetch appointments:", res.statusText);
      }

    }

    catch (err) {
      console.error("Error fetching appointments:", err);
    }

    finally {
      setLoading(false);
    }

  };

  useEffect(() => {
    getAllAppointmentData();
  }, []);

  function convertTo24Hour(timeStr) {
    const date = new Date("1970-01-01 " + timeStr);
    return date.getHours() * 100 + date.getMinutes();
  };

  function calculateAge(dob) {

    if (!dob) {
      return "";
    }

    let day, month, year;

    if (dob.includes('/')) {
      [day, month, year] = dob.split('/').map(part => parseInt(part, 10));
    } else if (dob.length === 8) {

      day = parseInt(dob.substring(0, 2), 10);
      month = parseInt(dob.substring(2, 4), 10);
      year = parseInt(dob.substring(4, 8), 10);
    } else {
      return "";
    }

    const dobDate = new Date(year, month - 1, day);

    const today = new Date();

    let age = today.getFullYear() - dobDate.getFullYear();

    const hasBirthdayPassed =
      today.getMonth() > dobDate.getMonth() ||
      (today.getMonth() === dobDate.getMonth() && today.getDate() >= dobDate.getDate());

    if (!hasBirthdayPassed) {
      age--;
    }

    return `${age.toString()} years old`;

  };

  return (
    <div>
      {loading && <LoadingComponent loading={teleConsultationModel} />}
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "start",
          justifyContent: "space-between",
          gap: "1rem",
        }}
      >

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            width: "fit-content",
            // margin: "auto", // Removed to fix alignment
          }}
        >
          <div>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                "& > div": {
                  minWidth: 256,
                  display: "flex",
                  flexDirection: "column",
                },
                "& > div > div, & > div > div > div, & .MuiCalendarPicker-root": {
                  width: 256,
                },
                "& .MuiTypography-caption": {
                  width: DATE_SIZE,
                  margin: 0,
                },
                "& .PrivatePickersSlideTransition-root": {
                  minHeight: DATE_SIZE * 6,
                  marginBottom: 0,
                  paddingBottom: 0,
                },
                '& .PrivatePickersSlideTransition-root [role="row"]': {
                  margin: 0,
                },
                "& .MuiPickersDay-dayWithMargin": {
                  margin: 0,
                },
                "& .MuiPickersDay-root": {
                  width: DATE_SIZE,
                  height: DATE_SIZE,
                },
                height: "20rem",
                marginBottom: 0,
                paddingBottom: 0,
                marginLeft: 1,
              }}
            >
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <StaticDatePicker
                  displayStaticWrapperAs="desktop"
                  openTo="day"
                  views={["day"]}
                  value={selectedDay}
                  onChange={handleSelectDay}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      InputProps={{
                        style: {
                          fontFamily: '"Poppins", sans-serif',
                          fontWeight: 400,
                        },
                      }}
                      sx={{ width: "100%" }}
                    />
                  )}
                  sx={{
                    ".Mui-selected": {
                      backgroundColor: "#7FD67F !important",
                      color: "var(--themePrimaryColor, #3B362A)",
                      fontFamily: '"Poppins", sans-serif',
                      fontWeight: 500,
                    },
                    width: "100%",
                    paddingBottom: 0,
                    marginBottom: 0,
                    marginLeft: 2,
                    marginTop: 2,
                    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.15)",
                    borderRadius: "8px",
                  }}
                />
              </LocalizationProvider>
            </Box>
          </div>
          <Box sx={{ width: 275, marginTop: 2, marginLeft: 3 }}>

            {isLast30Days && (
              <Box
                sx={{
                  backgroundColor: "var(--themeSecondaryColor, #FFF4E5)",
                  border: "1px solid var(--themePrimaryColor, #DA6E0B)",
                  borderRadius: "8px",
                  padding: "10px",
                  marginBottom: "10px",
                  textAlign: "center",
                }}
              >
                <p style={{ fontSize: "12px", color: "var(--themePrimaryColor, #DA6E0B)", margin: 0 }}>
                  No new appointments today.
                </p>
                <p style={{ fontSize: "14px", fontWeight: "bold", color: "var(--themePrimaryColor, #DA6E0B)", margin: 0 }}>
                  Showing last 30 days
                </p>
              </Box>
            )}

            <div
              className="Today-appointment shadow-lg hover:shadow-xl transition-shadow rounded-lg p-4"
            >
              <div className="Today-appointment-title">
                <div>
                  <p className="date-text" style={{ fontSize: "20px" }}>
                    {selectedDay &&
                      new Date(selectedDay)
                        .toLocaleDateString("en-GB", {
                          day: "2-digit",
                          month: "short",
                          year: "numeric",
                        })
                        .replace(/ /g, " ")}
                  </p>
                  <p className="day-text" style={{ fontSize: "20px" }}>
                    {selectedDay &&
                      new Date(selectedDay).toLocaleDateString("en-GB", {
                        weekday: "long",
                      })}
                  </p>
                </div>
                <div className="Appointment-count">
                  {isLast30Days ? 0 : consultationData?.length}
                </div>
              </div>
            </div>
            {/* Total Appointments Section */}
            <div
              className="Today-appointment mt-2 mb-4 shadow-lg hover:shadow-xl transition-shadow rounded-lg p-4 cursor-pointer"
              onClick={() => navigate("/AllAppointments")}
            >
              <div className="Today-appointment-title">
                <div>
                  <p>Total Appointments</p>
                </div>
                <div className="Appointment-count">{appointments?.length}</div>
              </div>
            </div>
          </Box>
        </Box>

        {/* Right Side */}
        <Box sx={{ flex: 2 }} className="list-appointments">
          <TableContainer
            style={{ borderRadius: "8px" }}
            className="AppointmentTable"
          >
            <Table>
              <StyledTableHead>
                <TableRow>
                  <TableCell className="tableheadtitle">Patient Name</TableCell>
                  <TableCell className="tableheadtitle" align="center">Age</TableCell>
                  <TableCell className="tableheadtitle" align="center">Gender</TableCell>
                  <TableCell className="tableheadtitle" align="center">UID</TableCell>
                  <TableCell className="tableheadtitle" align="center">Kiosk</TableCell>
                  <TableCell className="tableheadtitle" align="center">Date</TableCell>
                  <TableCell className="tableheadtitle"></TableCell>
                </TableRow>
              </StyledTableHead>
              <TableBody>
                {consultationData.length > 0 ? (
                  <>
                    {consultationData
                      ?.sort((a, b) => {
                        if (
                          a.appointment_status === "upcoming" &&
                          b.appointment_status !== "upcoming"
                        )
                          return -1;
                        if (
                          a.appointment_status !== "upcoming" &&
                          b.appointment_status === "upcoming"
                        )
                          return 1;
                        return (
                          convertTo24Hour(a.appointment_time) -
                          convertTo24Hour(b.appointment_time)
                        );
                      })
                      ?.map((row, index) => (
                        <>
                          <TableRow key={index} className="TableRowContainer">
                            <TableCell>{row?.firstname} {row?.lastname}</TableCell>

                            <TableCell align="center">{calculateAge(row?.dob)}</TableCell>

                            <TableCell align="center">
                              {row?.gender}
                            </TableCell>

                            <TableCell align="center" sx={{ fontFamily: "monospace", fontSize: "0.8rem", color: "#555" }}>
                              {row?.UID || "–"}
                            </TableCell>

                            <TableCell align="center" sx={{ maxWidth: 160 }}>
                              {row?.kiosk_name ? (
                                <Typography
                                  variant="caption"
                                  sx={{
                                    display: "inline-block",
                                    bgcolor: getKioskStyles(row.kiosk_name).bgcolor,
                                    color: getKioskStyles(row.kiosk_name).color,
                                    px: 1,
                                    py: 0.5,
                                    borderRadius: "6px",
                                    fontWeight: 600,
                                    fontSize: "0.72rem",
                                    lineHeight: 1.4,
                                    textAlign: "center",
                                  }}
                                >
                                  {row.kiosk_name}
                                </Typography>
                              ) : (
                                <Typography variant="caption" sx={{ color: "#bbb" }}>–</Typography>
                              )}
                            </TableCell>

                            <TableCell align="center">
                              {row?.updated_at
                                ? dayjs(row.updated_at).format("DD-MM-YYYY")
                                : (row?.created_at ? dayjs(row.created_at).format("DD-MM-YYYY") : "–")}
                            </TableCell>

                            <TableCell align="right">
                              <Button
                                style={{
                                  width: "100%",
                                  textTransform: "none",
                                  borderRadius: "5px",
                                  border: "1px solid var(--themePrimaryColor, #DA6E0B)",
                                  color: "var(--themePrimaryColor, #DA6E0B)",
                                  fontFamily: "'Poppins', sans-serif",
                                  fontWeight: 500,
                                  padding: "3px",
                                }}
                                onClick={() => {
                                  setSelectedAppointemntdetails(row);
                                  navigate(`/Patient/${row.UID}`);
                                }}
                              >
                                View Profile
                              </Button>
                            </TableCell>
                          </TableRow>
                        </>
                      ))}
                  </>
                ) : (
                  <div className="NoAppointments flex items-center ">
                    <img
                      src="/icons/clock.png"
                      alt="Time"
                      className="w-6 mb-2 mr-1 items-center"
                    />
                    <p className="text-sm" style={{ color: "var(--themePrimaryColor, #DA6E0B)" }}> New Appointments</p>
                  </div>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Box>
    </div>
  );

};

export default Appointments;
